const SeoModel = {};
SeoModel.titleByGameId = {};
SeoModel.metaByGameId = {};

// TODO: возможно выпилить
// eslint-disable-next-line no-unused-vars
const defaultTitle = (game) => `${game.fullTitle} Boosting and Coaching Services`;
// eslint-disable-next-line no-unused-vars
const boostingOnlyTitle = (game) => `${game.fullTitle} Boosting`;

/* eslint-disable max-len */
// eslint-disable-next-line no-unused-vars
const defaultMeta = (game) => ({
  title: `${game.fullTitle} Boosting Service - Buy ${game.title} Carry and Coaching Services | SkyCoach`,
  description: `Buy ${game.fullTitle} Boosting Services 🌟 and enjoy professional carry in all categories. Fast ⚡ and 100% Safe Coaching and Carry Services of any type, leveling & gearing. 🎮 Get fast & cheap ${game.fullTitle} boost from Skycoach Pro Players Team available 24/7.`,
});
/* eslint-disable max-len */
// eslint-disable-next-line no-unused-vars
const boostingOnlyMeta = (game) => ({
  title: `${game.fullTitle} Boosting Service - Buy ${game.title} Carry | SkyCoach`,
  description: `Buy ${game.fullTitle} Boosting Services 🌟. Fast ⚡ and 100% Safe Carry Services of any type, leveling & gearing. 🎮 Get fast & cheap ${game.fullTitle} boost from Skycoach Pro Players Team available 24/7.`,
});
/* eslint-enable max-len */

export const buildSeoModelByGame = (game) => {
  SeoModel.metaByGameId[game.id] = {
    title: game.seo_full_title,
    description: game.seo_description,
  };

  SeoModel.titleByGameId[game.id] = game.seo_title || defaultTitle(game);
};

export default SeoModel;
